import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

export function useDeletePosBankMutation(options = {}) {
  return useMutation(() => {
    return http.delete(HTTP_ENDPOINTS.deleteInbox());
  }, options);
}
